import continueJourney from '~/assets/continueJourney.svg';

interface ErrorScreenProps {
  title: string;
  message: string;
  ctaText: string;
  onButtonClick: () => void;
}

const ErrorScreen = ({
  title,
  message,
  onButtonClick,
  ctaText,
}: ErrorScreenProps) => {
  return (
    <div className="w-full h-[100vh] relative flex flex-col items-center justify-center bg-white px-4 pb-16 sm:pb-0">
      <img src={continueJourney} alt="continue journey" />
      {title && (
        <h2 className="text-lg sm:text-xl font-medium text-gray-900 text-center mt-4">
          {title}
        </h2>
      )}
      <p className="text-sm sm:text-base text-gray-500 text-center mt-2">
        {message}
      </p>
      <button
        type="button"
        onClick={onButtonClick}
        className="absolute bottom-4 left-4 right-4 sm:relative sm:bottom-auto sm:left-auto sm:right-auto sm:mt-4 sm:w-auto sm:rounded bg-gray-800 hover:bg-gray-900 text-white text-[15px] font-medium py-4 sm:py-3 px-8 sm:px-10 rounded transition-colors"
      >
        {ctaText}
      </button>
    </div>
  );
};

export default ErrorScreen;
